import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=cd7250c2&scoped=true&lang=css"

import exportComponent from "/__w/fqp-bridge.frontend/fqp-bridge.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd7250c2"]])

export default __exports__